import { render, staticRenderFns } from "./AdminAccessList.vue?vue&type=template&id=3a56f454&scoped=true&"
import script from "./AdminAccessList.vue?vue&type=script&lang=js&"
export * from "./AdminAccessList.vue?vue&type=script&lang=js&"
import style0 from "./AdminAccessList.vue?vue&type=style&index=0&id=3a56f454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a56f454",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a56f454')) {
      api.createRecord('3a56f454', component.options)
    } else {
      api.reload('3a56f454', component.options)
    }
    module.hot.accept("./AdminAccessList.vue?vue&type=template&id=3a56f454&scoped=true&", function () {
      api.rerender('3a56f454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin-access/AdminAccessList.vue"
export default component.exports